import { PrivateAxios } from "../../request/axios";
import Swal from 'sweetalert2';
import DOMPurify from 'dompurify';

export const sanitizeInput = (input) => {
    return DOMPurify.sanitize(input); // Nettoie les entrées utilisateur
};

export const hasPermissionForTag = (zone, userRoles) => {
    if (userRoles.includes('Saisie') && (zone === 'all' || zone === 'ug' || zone === 'int')) {
        return { reponse: true, zone: 'all' }
    }

    if (userRoles.includes('Saisie_UG') && (zone === 'ug' || zone === 'int')) {
        return { reponse: true, zone: 'ug' }
    }

    if (userRoles.includes('Saisie_INT') && zone === 'int') {
        return { reponse: true, zone: 'int' }
    }

    return { reponse: false, zone: '' }
};


export const hasPermissionForCancel = (zone, userRoles) => {
    if (userRoles.includes('Annuler') && (zone === 'all' || zone === 'ug' || zone === 'int')) {
        return { reponse: true, zone: 'all' }
    }

    if (userRoles.includes('Annuler_UG') && (zone === 'ug' || zone === 'int')) {
        return { reponse: true, zone: 'ug' }
    }

    if (userRoles.includes('Annuler_INT') && zone === 'int') {
        return { reponse: true, zone: 'int' }
    }

    return { reponse: false, zone: '' }
};

export const hasPermissionForModifyContrat = (zone, userRoles) => {
    if (userRoles.includes('Modifier_Contrat') && (zone === 'all' || zone === 'ug' || zone === 'int')) {
        return { reponse: true, zone: 'all' }
    }

    if (userRoles.includes('Modifier_Contrat_UG') && (zone === 'ug' || zone === 'int')) {
        return { reponse: true, zone: 'ug' }
    }

    if (userRoles.includes('Modifier_Contrat_INT') && zone === 'int') {
        return { reponse: true, zone: 'int' }
    }

    return { reponse: false, zone: '' }
};

export const getCategorie = (dateNaissance, fromDate = null) => {
    const age = getAge(dateNaissance, fromDate);
    if (age < 12) return '-12 ans';
    if (age < 18) return '-18 ans';
    if (age < 70) return 'Adulte';
    return 'Senior';
};

export const getAge = (dateString, fromDate = null) => {
    const referenceDate = fromDate ? new Date(fromDate) : new Date(); // Utilise fromDate si fourni, sinon la date actuelle
    const birthDate = new Date(dateString);
    let age = referenceDate.getFullYear() - birthDate.getFullYear();
    const monthDiff = referenceDate.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && referenceDate.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
};

export const calculateDays = (dateDepart, dateRetour) => {
    const startDate = new Date(dateDepart);
    const endDate = new Date(dateRetour);
    return (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;
};

export const downloadPDF = async (contratId, setIsLoading=null) => {
    try {
        if (setIsLoading) setIsLoading(true);
        const uri = `/contrat/download/${contratId}`;

        const response = await PrivateAxios.get(uri, {
            responseType: 'blob',
        });

        if (response.status !== 200) {
            throw new Error('Erreur lors de la récupération du PDF.');
        }

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        // Utiliser une approche plus sécurisée sans appendChild
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `contrat_${contratId}.pdf`);
        link.style.display = 'none';  // Masquer l'élément au lieu de l'ajouter au DOM
        document.body.appendChild(link);  // Toujours nécessaire pour activer le lien dans certains navigateurs
        link.click();
        link.remove();  // Utiliser remove() pour éviter de laisser un élément "orphelin"
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Erreur lors du téléchargement du PDF:', error);
        Swal.fire({
            title: "Erreur de téléchargement !",
            text: "Merci de contacter l'administrateur",
            icon: "error"
        });
    } finally {
        if (setIsLoading) setIsLoading(false);
    }
};


export const tagContrat = async (contrat, zone, setIsLoading, navigate) => {
    try {

        const result = await Swal.fire({
            title: 'Voulez-vous vraiment taguer ce contrat ?',
            text: "Cette action est irréversible.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, taguer !',
            cancelButtonText: 'Annuler',
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        });

        // Si l'utilisateur confirme
        if (result.isConfirmed) {
            const contratId = contrat.id;
            setIsLoading(true);
            const uri = `/contrat/${zone}/taguer/${contratId}`;

            const response = await PrivateAxios.put(uri);

            if (response.status !== 200) {
                throw new Error('Erreur lors du tag du contrat.');
            }

            // Afficher une alerte de succès avec bouton OK
            Swal.fire({
                title: 'Succès',
                text: `Le contrat ${contratId} a été tagué avec succès.`,
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                }
            }).then(() => {
                navigate(0);
            });

        }

    } catch (error) {
        console.error('Erreur lors du tag du contrat.', error);
        Swal.fire({
            title: 'Erreur',
            text: 'Une erreur est survenue lors du tag du contrat.',
            icon: 'error',
            confirmButtonColor: '#d33',
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        });
    } finally {
        setIsLoading(false);
    }
};

export const cancelContrat = async (contrat, zone, setIsLoading, navigate) => {
    try {

        const result = await Swal.fire({
            title: 'Voulez-vous vraiment annuler ce contrat ?',
            text: "Cette action est irréversible.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, annuler !',
            cancelButtonText: 'Annuler',
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        });

        // Si l'utilisateur confirme
        if (result.isConfirmed) {
            const contratId = contrat.id;
            setIsLoading(true);
            let uri = `/contrat/${zone}/annuler/${contratId}`;

            const response = await PrivateAxios.put(uri);

            if (response.status !== 200) {
                throw new Error('Erreur lors du tag du contrat.');
            }

            // Afficher une alerte de succès avec bouton OK
            Swal.fire({
                title: 'Succès',
                text: `Le contrat ${contratId} a été annulé avec succès.`,
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                }
            }).then(() => {
                navigate(0);
            });

        }

    } catch (error) {
        console.error('Erreur lors de l\'annulation du contrat.', error);
        Swal.fire({
            title: 'Erreur',
            text: 'Une erreur est survenue lors de l\'annulation du contrat.',
            icon: 'error',
            confirmButtonColor: '#d33',
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        });
    } finally {
        setIsLoading(false);
    }
};

// Fonction pour vérifier si le fichier est encodé en UTF-8
export const isValidUTF8 = (uint8Array) => {
    let i = 0;
    while (i < uint8Array.length) {
        if (uint8Array[i] <= 0x7F) {
            // Caractères ASCII (1 octet)
            i++;
        } else if (uint8Array[i] >= 0xC2 && uint8Array[i] <= 0xDF) {
            // Caractères à 2 octets
            if (i + 1 < uint8Array.length && uint8Array[i + 1] >= 0x80 && uint8Array[i + 1] <= 0xBF) {
                i += 2;
            } else {
                return false;
            }
        } else if (uint8Array[i] >= 0xE0 && uint8Array[i] <= 0xEF) {
            // Caractères à 3 octets
            if (i + 2 < uint8Array.length && uint8Array[i + 1] >= 0x80 && uint8Array[i + 1] <= 0xBF && uint8Array[i + 2] >= 0x80 && uint8Array[i + 2] <= 0xBF) {
                i += 3;
            } else {
                return false;
            }
        } else if (uint8Array[i] >= 0xF0 && uint8Array[i] <= 0xF7) {
            // Caractères à 4 octets
            if (i + 3 < uint8Array.length && uint8Array[i + 1] >= 0x80 && uint8Array[i + 1] <= 0xBF && uint8Array[i + 2] >= 0x80 && uint8Array[i + 2] <= 0xBF && uint8Array[i + 3] >= 0x80 && uint8Array[i + 3] <= 0xBF) {
                i += 4;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    return true;
};

export const formatDate = (dateString) => {
    
    if (!dateString) {
        return null;
    }
    // Séparer l'année, le mois et le jour de la date d'entrée
    const [year, month, day] = dateString.split('-');

    // Retourner la date dans le format souhaité 'JJ/MM/AAAA'
    return `${day}/${month}/${year}`;
};


/**
 * Transforme le payload du hook (id/nom/prenom) -> format backend (ID/nom/prenom)
 * - filtre les entrées vides
 * - conserve seulement {ID, prenom?, nom?}
 */
const mapHookPayloadToBackend = (payload /* { personnes: [{id, nom?, prenom?}] } */) => {
  if (!payload || !Array.isArray(payload.personnes)) return null;

  const personnes = payload.personnes
    .map(p => {
      const out = { id: p.id };
      if (p.prenom != null) out.prenom = p.prenom;
      if (p.nom != null) out.nom = p.nom;
      // retire les objets sans aucune modif
      return (out.prenom == null && out.nom == null) ? null : out;
    })
    .filter(Boolean);

  return personnes.length ? { data: { personnes } } : null;
};

/**
 * Envoie les modifications de personnes
 * @param {object} contrat - { id, ... }
 * @param {string} zone
 * @param {Function} setIsLoading
 * @param {Function} navigate
 * @param {object} hookPayload - { personnes: [{id, nom?, prenom?}, ...] }
 */
export const modifyContratPersonnes = async (contrat, zone, setIsLoading, navigate, hookPayload) => {
  try {
    // Construire l'objet "data" au format attendu par le backend
    const body = mapHookPayloadToBackend(hookPayload);

    if (!body) {
      await Swal.fire({
        title: 'Aucun changement',
        text: 'Vous devez modifier au moins un nom ou prénom avant de valider.',
        icon: 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      });
      return;
    }

    // Demande de confirmation
    const confirm = await Swal.fire({
      title: 'Valider les modifications ?',
      text: 'Les noms et prénoms modifiés seront enregistrés.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, valider',
      cancelButtonText: 'Annuler',
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' }
    });

    if (!confirm.isConfirmed) return;

    const contratId = contrat.id;
    setIsLoading(true);

    const uri = `/contrat/${zone}/modifier/${contratId}`;
    // Body attendu: { data: { personnes: [ {ID, prenom?, nom?}, ... ] } }
    const response = await PrivateAxios.put(uri, body);

    if (response.status !== 200) {
      throw new Error('Erreur lors de la modification du contrat.');
    }

    await Swal.fire({
      title: 'Succès',
      text: `Les personnes du contrat ${contratId} ont été modifiées avec succès.`,
      icon: 'success',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' }
    });

    navigate(0);
  } catch (error) {
    console.error('Erreur lors de la modification du contrat.', error);
    Swal.fire({
      title: 'Erreur',
      text: 'Une erreur est survenue lors de la modification du contrat.',
      icon: 'error',
      confirmButtonColor: '#d33',
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' }
    });
  } finally {
    setIsLoading(false);
  }
};

const pick = (obj, keys) =>
  keys.reduce((acc, k) => (k in obj ? (acc[k] = obj[k], acc) : acc), {});

const diffModifiable = (original, draft, fields) => {
  const out = {};
  fields.forEach((k) => {
    const v0 = original?.[k] ?? "";
    const v1 = draft?.[k] ?? "";
    // trim strings
    const t0 = typeof v0 === "string" ? v0.trim() : v0;
    const t1 = typeof v1 === "string" ? v1.trim() : v1;
    if (t1 !== t0) out[k] = t1;
  });
  return out;
};

/**
 * Envoie les modifs du souscripteur
 * PUT /contrat/${zone}/modifier/${contratId}
 * Body: { data: { souscripteur: { ...champs_modifiés } } }
 */
export const modifyContratSouscripteur = async (
  contrat, zone, setIsLoading, navigate,
  originalSouscripteur, draftSouscripteur, fields = []
) => {
  try {
    const changes = diffModifiable(originalSouscripteur, draftSouscripteur, fields);

    if (Object.keys(changes).length === 0) {
      await Swal.fire({
        title: "Aucun changement",
        text: "Modifiez un champ avant de valider.",
        icon: "info",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    const confirm = await Swal.fire({
      title: "Valider les modifications du souscripteur ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, valider",
      cancelButtonText: "Annuler",
      showClass: { popup: "animate__animated animate__fadeInDown" },
      hideClass: { popup: "animate__animated animate__fadeOutUp" },
    });
    if (!confirm.isConfirmed) return;

    setIsLoading(true);
    const uri = `/contrat/${zone}/modifier/${contrat.id}`;
    const body = { data: { souscripteur: changes } };

    const response = await PrivateAxios.put(uri, body);
    if (response.status !== 200) throw new Error("Erreur lors de la modification du souscripteur.");

    await Swal.fire({
      title: "Succès",
      text: `Le souscripteur du contrat ${contrat.id} a été modifié.`,
      icon: "success",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "OK",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showClass: { popup: "animate__animated animate__fadeInDown" },
      hideClass: { popup: "animate__animated animate__fadeOutUp" },
    });

    navigate(0);
  } catch (err) {
    console.error(err);
    Swal.fire({
      title: "Erreur",
      text: "Une erreur est survenue lors de l’enregistrement.",
      icon: "error",
      confirmButtonColor: "#d33",
      showClass: { popup: "animate__animated animate__fadeInDown" },
      hideClass: { popup: "animate__animated animate__fadeOutUp" },
    });
  } finally {
    setIsLoading(false);
  }
};
